import { Controller } from 'react-hook-form'
import UserFormField from '../../User/UserFormField'
import { DEFAULT_ERROR_MESSAGE, codePractices, useFormContextRequester } from '../utils/_utils'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import { CodePracticeIds } from '@toktokdoctech/tokapi-client'
import { useRequesterFormContext } from '../utils/requesterFormContext'

const CodePractice = () => {
    const { state } = useRequesterFormContext()
    const { control, setValue, watch } = useFormContextRequester()
    const currentHcs = useCurrentHcs()
    const currentCodePractice = watch('codePractice')

    const handleChange = (value?: CodePracticeIds) => {
        if (!value) return

        if (value === 'Employee') {
            if (state.isEditionMode && currentCodePractice === 'Liberal') {
                setValue('finessNum', undefined)
            } else {
                setValue('finessNum', currentHcs?.finessNum)
            }
            setValue('amNum', undefined)
        } else {
            setValue('finessNum', undefined)
        }

        setValue('codePractice', value)
    }

    return (
        <Controller
            control={control}
            name="codePractice"
            rules={{
                required: DEFAULT_ERROR_MESSAGE,
            }}
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    required
                    variant="select"
                    label="Mode d'exercice"
                    placeholder="Mode d'exercice"
                    noValueText="Choisir"
                    type="default"
                    name={field.name}
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    value={field.value || undefined}
                    onChange={handleChange}
                    options={codePractices}
                    renderOption={(val) => codePractices.find((p) => p.value === val)?.label || ''}
                />
            )}
        />
    )
}

export default CodePractice
